export default __webpack_public_path__ + "static/media/6.71713591.svg";